import { ActivityDetailDevice } from '../../../../types/activity-detail/ActivityDetailDevice';

import { ApiDeviceCustomNameListItem } from '../../../../types/user/ApiUserProfile';

export function getCustomDeviceName(customNameList: Array<ApiDeviceCustomNameListItem>, item: ActivityDetailDevice): string {
  // regex match 设备id deviceId 字段
  const findOne = customNameList.find(({ deviceId }) => deviceId && new RegExp(deviceId).test(item.name));
  return findOne ? findOne.customName : item.deviceName;
}
